export default __webpack_public_path__ + "static/media/contactus.54a96cda.jpg";